export const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const randomizeLeftRight = () => {
  return Math.random() < 0.5;
};

export const generateParticipantID = () => {
  const timestamp = Date.now();
  const random = Math.floor(Math.random() * 1000);
  return `P${timestamp}_${random}`;
};